<template>
  <div 
    v-bind:aria-labelledby="tabId"
    v-bind:hidden="!activeTab"
    v-bind:id="panelId"
    class="c-results__tabpanel"
    role="tabpanel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SearchTab",
  props: ["name", "panelSuffix", "tabSuffix", "isActive", "title", "resultsNumber"],
  data() {
    return {
      activeTab: this.isActive
    };
  },
  computed: {
    panelId() {
      return this.name + this.panelSuffix;
    },
    tabIndex() {
      return (this.activeTab) ? 0 : -1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/results/SearchTab.vue